/** A row of on/off choices under a small heading. Single or multiple choice is decided by the caller's `isOn`. */
export function Segmented<T extends string>({
  legend,
  options,
  isOn,
  onPick,
}: {
  legend: string;
  options: readonly { value: T; label: string }[];
  isOn: (value: T) => boolean;
  onPick: (value: T) => void;
}) {
  return (
    <fieldset className="seg-set">
      <legend>{legend}</legend>
      <div className="seg">
        {options.map((o) => (
          <button key={o.value} type="button" aria-pressed={isOn(o.value)} onClick={() => onPick(o.value)}>
            {o.label}
          </button>
        ))}
      </div>
    </fieldset>
  );
}
